import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UserData } from '@osapp/model';
import { DestroyableComponentBase } from '@osapp/modules/utils/components/destroyable-component-base';
import { PlatformService } from '@osapp/services';
import { ITerminalInfo } from 'apps/idl/src/modules/olaqin/models/iterminal-info';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { CapacitorPluginSce } from 'capacitor-plugin-sce';
import { EMPTY, from } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { EModule } from '../../../enums/EModule';
import { DrawerPopoverService } from '../../../services/drawer-popover.service';
import { LoaderService } from '../../../services/loader.service';
import { PanneauService } from '../../../services/panneau.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { ConfirmationDossierPatientComponent } from '../../confirmation-dossier-patient/confirmation-dossier-patient.component';
import { PanneauDossierPatientSuccesComponent } from '../panneau-dossier-patient-succes/panneau-dossier-patient-succes.component';

@Component({
  templateUrl: './panneau-correspondances-patients.component.html',
  styleUrls: ['./panneau-correspondances-patients.component.scss'],
})
export class PanneauCorrespondancesPatientsComponent extends DestroyableComponentBase implements OnDestroy{

  @Input() public patientCV: IPatient;
  @Input() public terminal: ITerminalInfo;
  @Input() public correspondancesPatient: IPatient[];
  @Input() public createNewPatient: Function;
  @Input() public mapScorePatients: Map<string, { pertinence: number, distance: number }>;
  public selectedPatient: IPatient | null = null;

  constructor(
    private svcPatients: PatientsService,
    private svcDrawerPopover: DrawerPopoverService,
    private svcLoader: LoaderService,
    private svcPanneau: PanneauService,
    private svcSnackbar: SnackbarService,
    private svcApp : PlatformService,
    private cdr: ChangeDetectorRef
  ) { 
    super();
  }

  public ngOnDestroy() {
    if (UserData.modules.includes(EModule.sce) && this.svcApp.isAndroid) {
      from(CapacitorPluginSce.disconnect()).pipe(
        takeUntil(this.destroyed$)
      ).subscribe();    
    }
    super.ngOnDestroy();
  }

  public onSelectPatient(patient: IPatient): void {
    this.selectedPatient = patient;
    this.cdr.detectChanges();
  }

  public selectCorrespondance(): void {
    this.svcDrawerPopover.open(
      "Confirmer le choix du patient",
      "auto",
      event.currentTarget,
      ConfirmationDossierPatientComponent,
      {
        confirm: () => {
          this.svcDrawerPopover.close();
          this.svcLoader.showLoader("Enregistrement des données");
          this.svcPatients.updatePatientFromCV(this.selectedPatient, this.patientCV, this.terminal).pipe(
            tap((patient: IPatient) => {
              this.svcLoader.hideLoader();
              this.svcPanneau.open('Lecture carte Vitale', PanneauDossierPatientSuccesComponent, { patient: patient });
            }),
            catchError(() => {
              this.svcLoader.hideLoader();
              this.svcSnackbar.showToast("error", "bottom center", "Une erreur s'est produite veuillez réessayer.", null, null, null, "7000");
              this.svcPanneau.close();
              return EMPTY;
            })
          ).subscribe();
        },
        cancel: () => {
          this.svcDrawerPopover.close();
        },
      }
    );
  }

  public onCreatePatient(patient: IPatient): void {
    if (this.createNewPatient) {
      this.svcLoader.showLoader("Enregistrement des données");
      this.createNewPatient(patient).pipe(
        tap((patient: IPatient) => {
          this.svcLoader.hideLoader();
          this.svcPanneau.open('Lecture carte Vitale', PanneauDossierPatientSuccesComponent, { patient: patient, nouveauPatient: true });
        })
      ).subscribe();
    }
  }
}
